// @flow
import {
	FETCH_PAYMENT_METHODS,
	INITIATE_FETCH_PAYMENT_METHODS,
	FETCH_PAYMENT_METHODS_SUCCESS,
	FETCH_PAYMENT_METHODS_ERROR,
	SELECT_PAYMENT_METHOD,
	LINK_PAYMENT_SEND_OTP,
	LINK_PAYMENT_SEND_OTP_SUCCESS,
	LINK_PAYMENT_METHOD,
	LINK_PAYMENT_METHOD_SUCCESS,
	MAKE_PAYMENT,
	PAYMENT_SUCCESS,
	PAYMENT_ERROR,
	RESET_PAYMENT,
	PAYTM_ADD_MONEY_RES,
	OPEN_CARD_CVV,
	SET_PAYMENT,
	CAPTURE_PAYMENT,
	FETCH_PENDING_BALANCE,
	FETCH_PENDING_BALANCE_SUCCESS,
	FETCH_PENDING_BALANCE_ERROR,
	NEUU_WALLET_MAKE_PAYMENT,
	DEBOUNCE_FETCH_PAYMENT_METHODS,
	POOL_PAYMENT_STATUS,
	CANCEL_POOL_PAYMENT_STATUS,
	UPI_COLLECT_PAYMENT,
	SELECTED_PAYMENT_ERROR,
	RESET_VERIFICATION,
	EDIT_UPI_VPA,
	CLEAR_UPI_VPA,
	CLEAR_UPI_VPA_SUCCESS,
	CLEAR_UPI_VPA_ERROR,
	ADD_MONEY_PG,
	SHOW_PAYMENT_GATEWAY,
} from './types';
import type { Action } from './types';

export const fetchPaymentMethods = (
	mobile: string,
	sessionId: string,
	order: any,
	type: string = 'CART',
	invoiceAmount: number = 0,
	deliveryFee: number = 0,
  addressId:? string,
	affiliateName: ?string
): Action => ({
	type: FETCH_PAYMENT_METHODS,
	payload: { mobile, sessionId, order, type, invoiceAmount, deliveryFee, affiliateName, addressId },
});

export const initiateFetchPayment = (): Action => ({
	type: INITIATE_FETCH_PAYMENT_METHODS,
});

export const fetchPaymentMethodSuccess = (payload: {
	orderId: string,
	paymentMethods: Array<any>,
	amount: number,
}): Action => ({
	type: FETCH_PAYMENT_METHODS_SUCCESS,
	payload,
});

export const fetchPaymentMethodError = (error: any): Action => ({
	type: FETCH_PAYMENT_METHODS_ERROR,
	payload: error,
});

export const selectPayment = (selectedPayment: any): Action => ({
	type: SELECT_PAYMENT_METHOD,
	payload: selectedPayment,
});

export const linkPaymentSendOTP = (payload: {}): Action => ({
	type: LINK_PAYMENT_SEND_OTP,
	payload,
});

export const linkPaymentSendOTPSuccess = (payload: {}): Action => ({
	type: LINK_PAYMENT_SEND_OTP_SUCCESS,
	payload,
});

export const linkPayment = (payload: {}): Action => ({
	type: LINK_PAYMENT_METHOD,
	payload,
});

export const linkPaymentSuccess = (payload: {}): Action => ({
	type: LINK_PAYMENT_METHOD_SUCCESS,
	payload,
});

export const makePayment = (payload: {}): Action => ({
	type: MAKE_PAYMENT,
	payload,
});

export const paymentSuccess = (payload: {}): Action => ({
	type: PAYMENT_SUCCESS,
	payload,
});

export const showPaymentGateway = (payload: {}): Action => ({
	type: SHOW_PAYMENT_GATEWAY,
	payload,
});

export const paymentError = (payload: Error): Action => ({
	type: PAYMENT_ERROR,
	payload,
});

export const resetPayment = (): Action => ({
	type: RESET_PAYMENT,
});

export const processPaytmAddMoneyRes = (payload: {}): Action => ({
	type: PAYTM_ADD_MONEY_RES,
	payload,
});

export const openCvvText = (payload: {}): Action => ({
	type: OPEN_CARD_CVV,
	payload,
});

export const setPayment = (payload: {}): Action => ({
	type: SET_PAYMENT,
	payload,
});

export const capturePayment = (payload: {}): Action => ({
	type: CAPTURE_PAYMENT,
	payload,
});

export const fetchPendingBalance = (mobile: string): Action => ({
	type: FETCH_PENDING_BALANCE,
	payload: mobile,
});

export const fetchPendingBalanceSuccess = (amount: number): Action => ({
	type: FETCH_PENDING_BALANCE_SUCCESS,
	payload: amount,
});

export const fetchPendingBalanceError = (error: Error): Action => ({
	type: FETCH_PENDING_BALANCE_ERROR,
	payload: error,
});

export const neuuWalletPayment = (mobile: string, amount: number, order: any, sessionId: string, deliveryFee: number, addressId:? string, affiliateName:? string): Action => ({
	type: NEUU_WALLET_MAKE_PAYMENT,
	payload: { mobile, sessionId, amount, order, deliveryFee, affiliateName, addressId },
});

export const debFetchPaymentMethods = (
	mobile: string,
	sessionId: string,
	order: any,
	type: string = 'CART',
	invoiceAmount: number = 0,
	deliveryFee: number = 0,
  addressId:? string,
	affiliateName: ?string
): Action => ({
	type: DEBOUNCE_FETCH_PAYMENT_METHODS,
	payload: { mobile, sessionId, order, type, invoiceAmount, deliveryFee, affiliateName },
});

export const poolPaymentStatus = (payload: {}): Action => ({
	type: POOL_PAYMENT_STATUS,
	payload,
});

export const cancelPoolPaymentStatus = (): Action => ({
	type: CANCEL_POOL_PAYMENT_STATUS,
});

export const upiCollectPayment = (payload: {}): Action => ({
	type: UPI_COLLECT_PAYMENT,
	payload,
});

export const setSelectedPaymentError = (payload: {}): Action => ({
	type: SELECTED_PAYMENT_ERROR,
	payload,
});

export const resetVerification = (): Action => ({
	type: RESET_VERIFICATION,
});

export const editUpiVpa = (payload: {}): Action => ({
	type: EDIT_UPI_VPA,
	payload,
});

export const clearVpa = (paymentMethod: {}, mobile: string): Action => ({
	type: CLEAR_UPI_VPA,
	payload: { paymentMethod, mobile },
});

export const clearVpaSuccess = (payload: {}): Action => ({
	type: CLEAR_UPI_VPA_SUCCESS,
	payload,
});

export const clearVpaError = (payload: Error): Action => ({
	type: CLEAR_UPI_VPA_ERROR,
	payload,
});

export const pgAddMoney = (payload: {}): Action => ({
	type: ADD_MONEY_PG,
	payload,
});
